import { Box } from "@mui/material";
import { formatToMillions, roundToDecimalPlaces } from "../../../utils/numbers";

export const MetricBox = ({
  title,
  value,
  change,
}: {
  title: string;
  value: number;
  change: number;
}) => {
  const isPositive = (num: number) => num >= 0;
  const isChangePositive = isPositive(Number(roundToDecimalPlaces(change)));

  return (
    <Box
      sx={{
        // backgroundColor: "action.hover",
        width: "33%",
        borderRadius: 1,
        p: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ fontSize: 12, textAlign: "center", width: "100%" }}>
        {title}
      </Box>
      <Box
        sx={{
          fontSize: 24,
          textAlign: "center",
          fontWeight: "bold",
          width: "100%",
        }}
      >
        {formatToMillions(value)}
      </Box>

      <Box
        sx={{
          fontSize: 12,
          textAlign: "center",
          width: "100%",
          color: isChangePositive ? "green" : "red",
        }}
      >
        {roundToDecimalPlaces(change) === "0"
          ? "no change"
          : isChangePositive
          ? "+" + roundToDecimalPlaces(change) + "%"
          : "" + roundToDecimalPlaces(change) + "%"}
        {" vs. last run"}
      </Box>
    </Box>
  );
};
